import { Switch, Typography } from "antd";
import React, { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import InfoWhiteIcon from "../../assets/icons/info-white-new.svg";
import FreeSubscriptionHelpModal from "../freeSubscription/modals/FreeSubscriptionHelpModal";
import "./index.less";

type ToggleOption = "collection" | "subscription" | "chat";

type EditProfileToggleProps = {
  type: ToggleOption;
  handleOnChange: (name: string, value: string) => void;
  userSettingsInfos: any;
};

const EditProfileToggleComponent: React.FC<EditProfileToggleProps> = ({ type, handleOnChange, userSettingsInfos }) => {
  const { t } = useTranslation();

  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [showHelpModal, setShowHelpModal] = useState<boolean>(false);

  useEffect(() => {
    if (userSettingsInfos) {
      if (type === "collection") {
        setIsChecked(userSettingsInfos.defaultPage === "collection");
      } else if (type === "chat") {
        setIsChecked(userSettingsInfos.chat === "free");
      } else if (type === "subscription") {
        setIsChecked(userSettingsInfos.isFreeSubscription === true);
      }
    }
  }, [userSettingsInfos, type]);

  const handleToggle = (checked: boolean) => {
    setIsChecked(checked);

    if (type === "collection") {
      handleOnChange("defaultPage", checked ? "collection" : "feeds");
    } else if (type === "chat") {
      handleOnChange("chat", checked ? "free" : "subscriber");
    } else if (type === "subscription") {
      handleOnChange("isFreeSubscription", checked ? "true" : "false");
    }
  };

  const getContent = () => {
    switch (type) {
      case "collection":
        return {
          title: t("featured-collection-title"),
          description: t("featured-collection-description"),
        };
      case "subscription":
        return {
          title: t("free-subscription-title"),
          description: t("free-subscription-description"),
        };
      case "chat":
        return {
          title: t("free-chat-title"),
          description: t("free-chat-description"),
        };
    }
  };

  const content = getContent();

  return (
    <>
      <div className="edit-profile-toggle-wrapper">
        <div className="edit-profile-toggle-header">
          <div className="edit-profile-toggle-title-container">
            <Typography.Text className="edit-profile-toggle-title">{content.title}</Typography.Text>
            {type === "subscription" && (
              <img src={InfoWhiteIcon} className="edit-profile-toggle-info-icon" alt="Info" onClick={() => setShowHelpModal(true)} />
            )}
          </div>
          <Switch checked={isChecked} onChange={handleToggle} className="edit-profile-toggle-switch" />
        </div>
        <Typography.Text className="edit-profile-toggle-description">{content.description}</Typography.Text>
      </div>
      {showHelpModal && <FreeSubscriptionHelpModal onClose={() => setShowHelpModal(false)} />}
    </>
  );
};

export default memo(EditProfileToggleComponent);
